/**
 * GTM Event Tracking Utilities
 * All events use snake_case naming convention
 */

export const pushGTMEvent = (event: string, data?: Record<string, unknown>) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }

  window.dataLayer.push({
    event,
    ...data,
  });
};

// Event name constants (all snake_case)
export const GTM_EVENTS = {
  // Main funnel events
  START_SIGN_UP: 'start_sign_up',
  ADD_SHIPPING: 'add_shipping',
  SIGN_UP: 'sign_up',
  INITIATE_CHECKOUT: 'initiate_checkout',
  PURCHASE: 'purchase',
  START_QUIZ: 'start_quiz',
  QUIZ_COMPLETE: 'quiz_complete',
  ONBOARDING_COMPLETE: 'onboarding_complete',

  // Additional events
  COMPLETE_REGISTRATION: 'complete_registration',
  TREATMENT_AGREEMENT_VIEWED: 'treatment_agreement_viewed',
  ADD_TO_CART: 'add_to_cart',

  // Questionnaire tracking
  QUESTIONNAIRE_STEP_VIEWED: 'questionnaire_step_viewed',
  QUESTIONNAIRE_STARTED: 'questionnaire_started',

  // Results tracking
  RESULTS_VIEWED: 'results_viewed',
} as const;
